import { render, staticRenderFns } from "./ModalStationEdit.vue?vue&type=template&id=52c12af6&scoped=true"
import script from "./ModalStationEdit.vue?vue&type=script&lang=js"
export * from "./ModalStationEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalStationEdit.vue?vue&type=style&index=0&id=52c12af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c12af6",
  null
  
)

export default component.exports